import API from "../configs/axiosInstance";

const getScanConfiguration = (domainId) => {
  return API({
    url: `/account-service/v1/scan-configurations/${domainId}/by-domain-id`,
    method: "GET",
  });
};

const upsertScanConfiguration = (domainId, data) => {
  return API({
    url: `/account-service/v1/scan-configurations/${domainId}/by-domain-id`,
    method: "PUT",
    data,
  });
};

const scanConfigurationService = {
  getScanConfiguration,
  upsertScanConfiguration,
};

export default scanConfigurationService;
